var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame131(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 226,
    viewBox: "0 0 402 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M232.646 88.5359L20.3004 288.933L300.023 372.631L232.646 88.5359Z",
    stroke: "url(#paint0_linear_64_6549)",
    strokeWidth: 20,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M244.083 47.0571L5.31009 272.394L319.843 366.509L244.083 47.0571Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M208.087 170.612L67.6874 303.111L252.635 358.451L208.087 170.612Z",
    stroke: "url(#paint1_linear_64_6549)",
    strokeWidth: 20,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_6549",
    x1: 157.295,
    y1: 340.362,
    x2: 238.38,
    y2: 69.3747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7436EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A47BF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_6549",
    x1: 157.295,
    y1: 340.362,
    x2: 213.821,
    y2: 151.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7436EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A47BF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame131);
export default __webpack_public_path__ + "static/media/Frame 131.8efca9dd0fd45facbd20648974101e10.svg";
export { ForwardRef as ReactComponent };